import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';
import { formatValueToCsvString } from './helpers/formatValueToCsvString';

export type TableColumnFormatNtpSummarySources<TRow, TObject> = {
  type: 'ntpSummarySources';
  field: KeyOfType<TRow, TObject | null>;
  toWebString: (value: TObject | null) => string;
};

export const createNtpSummarySourcesColumn: {
  <TRow, TObject>(
    config: TableDataColumnConfig<TRow, TObject | null> & {
      array?: false;
      toWebString: (value: TObject | null) => string;
    },
  ): TableColumnBase<TRow, TableColumnFormatNtpSummarySources<TRow, TObject>>;
  <TRow, TObject>(
    config: TableDataColumnConfig<TRow, TObject[] | null> & {
      array: true;
      toWebString: (value: TObject | null) => string;
    },
  ): TableColumnBase<
    TRow,
    TableColumnFormatNtpSummarySources<TRow, TObject | null>
  >;
} = <TRow, TObject>(
  config: TableDataColumnConfig<TRow, TObject | null> & {
    toWebString: (value: TObject | null) => string;
  },
): TableColumnBase<
  TRow,
  TableColumnFormatNtpSummarySources<TRow, TObject | null>
> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'ntpSummarySources',
    field: config.key,
    toWebString: config.toWebString,
  },
  csvStringDependencies: [config.key],
  webDependencies: [config.key],
  toCsvString: (row) => {
    const content = getValueFromKeyOfType(row, config.key);

    return formatValueToCsvString(
      content as TObject | TObject[] | null,
      (val) => (val ? config.toWebString(val) : ''),
    );
  },
  filter: createDefaultFilter(config.filter, undefined),
});
